const getCodeBin = epsgCode =>
  epsgCode.substring(0, epsgCode.length > 4 ? 2 : 1) + '000';

export const getProjection = epsgCode => {
  /* WARNING! This *CANNOT* be a for-loop or a lookup
   * as it is needed for WebPack to know how to do
   * the dynamic import.
   */
  let projPromise;
  switch (getCodeBin(epsgCode)) {
    case '2000':
      projPromise = import(/* webpackChunkName: "proj2000" */ './proj/2000.js');
      break;
    case '3000':
      projPromise = import(/* webpackChunkName: "proj3000" */ './proj/3000.js');
      break;
    case '4000':
      projPromise = import(/* webpackChunkName: "proj4000" */ './proj/4000.js');
      break;
    case '5000':
      projPromise = import(/* webpackChunkName: "proj5000" */ './proj/5000.js');
      break;
    case '6000':
      projPromise = import(/* webpackChunkName: "proj6000" */ './proj/6000.js');
      break;
    case '7000':
      projPromise = import(/* webpackChunkName: "proj7000" */ './proj/7000.js');
      break;
    case '20000':
      projPromise = import(
        /* webpackChunkName: "proj20000" */ './proj/20000.js'
      );
      break;
    case '21000':
      projPromise = import(
        /* webpackChunkName: "proj21000" */ './proj/21000.js'
      );
      break;
    case '22000':
      projPromise = import(
        /* webpackChunkName: "proj22000" */ './proj/22000.js'
      );
      break;
    case '23000':
      projPromise = import(
        /* webpackChunkName: "proj23000" */ './proj/23000.js'
      );
      break;
    case '24000':
      projPromise = import(
        /* webpackChunkName: "proj24000" */ './proj/24000.js'
      );
      break;
    case '25000':
      projPromise = import(
        /* webpackChunkName: "proj25000" */ './proj/25000.js'
      );
      break;
    case '26000':
      projPromise = import(
        /* webpackChunkName: "proj26000" */ './proj/26000.js'
      );
      break;
    case '27000':
      projPromise = import(
        /* webpackChunkName: "proj27000" */ './proj/27000.js'
      );
      break;
    case '28000':
      projPromise = import(
        /* webpackChunkName: "proj28000" */ './proj/28000.js'
      );
      break;
    case '29000':
      projPromise = import(
        /* webpackChunkName: "proj29000" */ './proj/29000.js'
      );
      break;
    case '30000':
      projPromise = import(
        /* webpackChunkName: "proj30000" */ './proj/30000.js'
      );
      break;
    case '31000':
      projPromise = import(
        /* webpackChunkName: "proj31000" */ './proj/31000.js'
      );
      break;
    case '32000':
      projPromise = import(
        /* webpackChunkName: "proj32000" */ './proj/32000.js'
      );
      break;
    default:
      projPromise = new Promise((resolve, reject) => {
        reject('Invalid EPSG code');
      });
  }
  return projPromise.then(list => list.default[epsgCode]);
};
